'use client';

import { logOutAction } from '@insta-club/action';
import { ApiKeys, fetcher } from '@insta-club/api';
import { useCustomForm } from '@insta-club/hooks';
import { useSessionStore } from '@insta-club/state';
import { Button, Form, Modal } from '@insta-club/ui';
import { AccountChangePasswordFormValues, AccountChangePasswordSchema } from '@insta-club/validator';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';
import PssswordInput from 'src/libs/ui/input/password';

const ChangePassword = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const router = useRouter();
    const clearSession = useSessionStore((state) => state.clearSession);

    const handleSignout = async () => {
        const response = await logOutAction();
        if (response?.success) {
            clearSession();
            router.push('/');
        }
    };

    const onSubmit: SubmitHandler<AccountChangePasswordFormValues> = async (data) => {
        try {
            const { old_password, password, password_confirmation } = data;
            await fetcher(ApiKeys.POST_CHANGE_PASSWORD, 'dashboard', 'POST', {
                body: {
                    old_password,
                    password,
                    password_confirmation
                }
            });
            handleSignout();
            toast.success('رمز عبور با موفقیت ذخیره شد.');
        } catch (err: unknown) {
            if (err instanceof Error) {
                toast.error('خطای ناشناخته رخ داده است');
            } else {
                const error = err as { error: { message: string } };
                toast.error(error.error.message);
            }
        }
    };

    const form = useCustomForm(AccountChangePasswordSchema);
    const { reset } = form;

    useEffect(() => {
        if (!open) {
            reset();
        }
    }, [open, reset]);

    return (
        <>
            <Modal
                title={'تغییر رمز عبور'}
                description={'برای ویرایش رمز عبور حساب کاربری خود اطلاعات زیر را با دقت وارد کنید.'}
                isOpen={open}
                onClose={onClose}
                closeOnOverlayClick={false}
            >
                <Form form={form} onSubmit={onSubmit}>
                    <div className='space-y-5'>
                        <PssswordInput name='old_password' label='رمز عبور قبلی' max={11} maxLength={11} />
                        <PssswordInput name='password' label='رمز عبور جدید' max={11} maxLength={11} />
                        <PssswordInput
                            name='password_confirmation'
                            label='تایید رمز عبور جدید'
                            max={11}
                            maxLength={11}
                        />

                        <Button loading={form.formState.isSubmitting} fullWidth type='submit'>
                            ذخیره تغییر رمز عبور
                        </Button>
                    </div>
                </Form>
            </Modal>
        </>
    );
};

export default ChangePassword;

